import src from "IMAGE";
export default { src, width: 587, height: 39, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AE1MTTVEREQhQT0zIERDQCE/OzYmSEhIJDk5ORVFRUUffL0HQmuNa8kAAAAASUVORK5CYII="};
